// @flow
// Externals
import React from "react";
import Lottie from "react-lottie-player";

// Styles
// $FlowFixMe
import "./index.scss";

// Animation Data
import animationData from "../../static/lottie/Q13.json";

// Question Animation
/*::
type Props = {
	value: string,
	options: string[]
}
*/

const Animation = (props /*: Props */) /*: any */ => {
	return (
		<div className="animation">
			<Lottie
				className="lottie-container basic"
				animationData={animationData}
				play={true}
				loop={true}
			/>
		</div>
	);
};

// Exports
export default Animation;
